import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeTabs = makeShortcode("CodeTabs");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`timestamp`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Required`}</em>{`. A timestamp representing when the measuring finished. The
format is either a string as defined in `}<a parentName="dd" {...{
            "href": "https://tools.ietf.org/html/rfc3339"
          }}>{`RFC
3339`}</a>{` or a numeric (integer or float)
value representing the number of seconds that have elapsed since the `}<a parentName="dd" {...{
            "href": "https://en.wikipedia.org/wiki/Unix_time"
          }}>{`Unix
epoch`}</a>{`.`}</dd></dl></p>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"timestamp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"2011-05-02T17:41:36.955Z"`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>
    <p>{`or: `}</p>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"timestamp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`1304358096.955`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      